module.exports = __webpack_public_path__ + "static/media/Zamzama (Ricalton, Jones, 1903).78e63db3.jpg";